export default [
    {
        title: '首页',
        path: '/',
        name: 'main',
        component: () => import('@/views/main/index'),
        meta: {
            key: 'main'
        },
        permission: false, //是否属于权限系统
        menu: true, //是否作为导航菜单
        permissionCheck: (_personal) => {
            //权限验证独有逻辑 只有permission是false的时候生效 参数是登录用户对象
            return true;
        }
    }
];
